import { ColumnsType } from 'antd/lib/table';

import { DocumentModel } from 'api/documents/documents.model';
import Table from 'components/Table';
import useDocumentTableRow from 'hooks/useDocumentTableRow';
import { CertificateDetailsModel } from 'models/certificate.model';

import { FilterableQueryResultType } from '../../../types';

type ListType = FilterableQueryResultType<DocumentModel<CertificateDetailsModel>> & {
  tableConfig?: ColumnsType<DocumentModel<CertificateDetailsModel>>;
  selectedTab?: string;
};

const List = ({ data, tableConfig, selectedTab }: ListType) => {
  const { onRowClick } = useDocumentTableRow(selectedTab);

  return (
    <Table
      numberOfRecords={data?.count}
      data={data?.rows || []}
      pagination
      config={tableConfig as ColumnsType<DocumentModel<CertificateDetailsModel>>}
      onRowClick={onRowClick}
      rowKey={(certificate) => certificate.jobId}
    />
  );
};

export default List;
